import type { StatusCliente } from './schemas';

export const STATUS_LABEL: Record<StatusCliente, string> = {
  ativo: 'Ativo',
  inativo: 'Inativo',
  falecido: 'Falecido',
  suspenso: 'Suspenso',
};

export const STATUS_TONE: Record<StatusCliente, 'ok' | 'warn' | 'danger' | 'neutral'> = {
  ativo: 'ok',
  inativo: 'neutral',
  falecido: 'neutral',
  suspenso: 'danger',
};

export const ESTADO_CIVIL_LABEL: Record<string, string> = {
  solteiro: 'Solteiro(a)',
  casado: 'Casado(a)',
  divorciado: 'Divorciado(a)',
  uniao_estavel: 'União estável',
  viuvo: 'Viúvo(a)',
};

export const SEXO_LABEL: Record<string, string> = { M: 'Masculino', F: 'Feminino', O: 'Outro' };

// Saúde do CAF — calcula a partir da data de validade.
export type CafHealth = 'ok' | 'vencendo' | 'vencido' | 'sem_caf';

export function cafHealthFor(dataValidade: string | null | undefined): CafHealth {
  if (!dataValidade) return 'sem_caf';
  const validade = new Date(dataValidade);
  if (Number.isNaN(validade.getTime())) return 'sem_caf';
  const now = Date.now();
  const diffDays = Math.floor((validade.getTime() - now) / (1000 * 60 * 60 * 24));
  if (diffDays < 0) return 'vencido';
  if (diffDays <= 30) return 'vencendo';
  return 'ok';
}

export function diasParaVencimento(dataValidade: string): number {
  const v = new Date(dataValidade);
  return Math.floor((v.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
}

export function formatCpf(raw: string): string {
  const d = raw.replace(/\D/g, '');
  if (d.length !== 11) return raw;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
}
